/****
 * Custom hook that detects the current device type based on screen size.
 *
 * Uses responsive breakpoints to determine whether the user is on
 * a mobile, tablet, or desktop device and exposes these values for
 * responsive UI behavior throughout the application.
 */
import { useMediaQuery } from "react-responsive";

import { breakpoints } from "@/config/breakpoints";

export const useDeviceType = () => {
  const isMobile = useMediaQuery({
    maxWidth: breakpoints.mobileMax,
  });

  const isTablet = useMediaQuery({
    minWidth: breakpoints.tabletMin,
    maxWidth: breakpoints.tabletMax,
  });

  const isDesktop = useMediaQuery({
    minWidth: breakpoints.desktopMin,
  });

  return {
    isMobile,
    isTablet,
    isDesktop,
  };
};
